import galeria from "./galeria";
import toggles from "./toggles";

import '../sass/app.scss';

galeria();
toggles();
